<template>
  <div class="d-flex">
    <MainBarMenuV2 />
    <div class="layout-content container-fluid">
      <HeadingUser />
      <div class="col-10 mx-auto my-5 p-0">
        <Breadcrumb :items="breadcrumb" />
        <div class="d-flex justify-content-between align-content-center pt-4">
          <Typography text="Historial de modificaciones" variant="h1" />
        </div>
        <div class="d-flex justify-content-between align-content-center py-4">
          <Input label="radicado" name="file_number" col="4" @input="event => file_number = event.target.value" :value="file_number" disabled/>
        </div>
        <!-- Table component -->
        <div>
          <div class="mt-2 mb-1">
            <datatable :columns="datatable.columns" :data="datatable.rows" :filter="datatable.filter"
              :per-page="datatable.perPage" :page="datatable.page" class="table table-hover table-borderless"
              id="my-table">
              <template slot-scope="{ row, columns }">
                <tr>
                  <template>
                    <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row"
                      class="cell-border">
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
            <div class="col-12">
              <b-pagination class="justify-content-center pt-3" v-model="pagina" :total-rows="datatable.total"
                :per-page="datatable.per_page" aria-controls="my-table"></b-pagination>
            </div>
            <div class="cont-no-data" v-show="datatable.rows.length <= 0">
              <div class="col-12 col-md-8 col-lg-7 mx-auto mt-3">
                <img src="@/assets/images/demands/user-mail.svg" alt="user email" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useControllers from "@/controllers";
const { useScreenHooks } = useControllers();
const { useLegal } = useScreenHooks();
const { useProcess } = useLegal();
const { usHistory } = useProcess();

export default usHistory;
</script>

<style  lang="scss" scoped src="./HistoryProcess.scss">

</style>